import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class ChatService {
    constructor(
        private httpService: HttpService
    ) { }

    /**
     *  获取上级用户 （消息列表）
     */
    getUpUser() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetUpUser';
        return this.httpService.get(url);
    }
    /**
     * 获取下级用户 （消息列表）
     */
    getSubUsers() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetSubUsers';
        return this.httpService.get(url);
    }
    /**
     *
     * 获取聊天记录
     */
    getChatMessage(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetChatMessage';
        return this.httpService.get(url, param);
    }
    /**
     *
     * 获取未读消息总数
     */
    getChatNewMessage() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetChatNewMessageCountByUser';
        return this.httpService.get(url);
    }
    /**
     *  获取未读消息列表，根据好友分组汇总
     */
    getChatNewMessageCountListByUser() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetChatNewMessageCountListByUser';
        return this.httpService.get(url);
    }
    /**
     * 添加新的消息
     *
     */
    addChatMessage(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/AddChatMessage';
        return this.httpService.post(url, param);
    }
    /**
     *
     * 获取和好友之间的消息交互
     */
    getetNewOrOldChatMessages(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetNewOrOldChatMessages';
        return this.httpService.get(url, param);
    }
    /**
     *  设置消息已读
     */
    SetChatMessageIsRead(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/SetChatMessageIsRead/' + param;
        return this.httpService.post(url, {});
    }
    /**
     * 获取是否被平台禁言
     */
    getChatIsBanned() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetChatUserBannedAsync';
        return this.httpService.get(url);

    };
    /**
     * 获取上下级用户包含下级用户的最新消息数量，和最新消息体
     *
     */
    getSubUsersOrMessage(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetSubUsersOrMessage';
        return this.httpService.get(url, param);
    }
    /**
     *
     * 聊天设置
     */
    getChatSetting() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetChatSetting';
        return this.httpService.get(url);
    }
    /**
     * 
     * 获取上下级所有用户 (联系人列表)
     */
    getUpUserOrSubUsers(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetUpUserOrSubUsers';
        return this.httpService.get(url, param);
    }
    /**
    * 代客充值获取充值暗号
    */
    getPayTheSecretCode() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetPayTheSecretCode';
        return this.httpService.get(url);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/chat.service.ts